import React from 'react'
import Icon1 from '../../Icons/premium-lead-list/Icon-1.svg'
import Icon2 from '../../Icons/premium-lead-list/Icon-2.svg'
import Icon3 from '../../Icons/premium-lead-list/Icon-3.svg'
import { ContainerWrapper } from '../Container'

const BenefitsSection = () => {
    const benefits = [
        {
            icon: Icon1,
            title: 'Save Time',
            description:
                'No more sifting through endless data. We do the hard work for you.',
        },
        {
            icon: Icon2,
            title: 'Increase Efficiency',
            description:
                'With a focused list, your marketing efforts will be more effective.',
        },
        {
            icon: Icon3,
            title: 'Boost Performance',
            description:
                'High-quality leads mean better opportunities and higher success rates.',
        },
    ]

    return (
        <ContainerWrapper>
            <div className="mx-auto bg-olm-light-yellow md:rounded-8xl rounded-10xl md:px-20 px-4 py-20 md:py-28">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center text-center p-4 w-full md:w-1/3 mb-4 md:mb-0">
                            <div className="mb-4 text-4xl">
                                <benefit.icon />
                            </div>
                            <h3 className="text-lg md:text-xl font-bold mb-2">
                                {benefit.title}
                            </h3>
                            <p className="text-gray-700">
                                {benefit.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </ContainerWrapper>
    )
}

export default BenefitsSection
